import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button, Icon, Dropdown } from 'semantic-ui-react';

import AttachmentAddPopup from './AttachmentAddPopup';
import Attachments from './Attachments';

import styles from './Architecture.module.scss';

const Architecture = React.memo(
  ({
    isAdmin,
    architectures,
    factories,
    onFetchArchitecture,
    onArchitectureDelete,
    onArchitectureCreate,
  }) => {
    const [t] = useTranslation();

    const [currentFactory, setCurrentFactory] = useState(
      (factories.length > 0 && factories[0]?.id) || 0,
    );

    const handleArchitectureCreate = useCallback(
      (newData) => {
        onArchitectureCreate(currentFactory, newData);
      },
      [currentFactory, onArchitectureCreate],
    );

    const factoryOptions = [];
    factories.forEach((ft) => {
      factoryOptions.push({ key: ft.id, value: ft.id, text: ft.name });
    });

    const handleChangeFactory = useCallback(
      (event, data) => {
        setCurrentFactory(data.value);
        onFetchArchitecture({ factoryId: data.value });
      },
      [onFetchArchitecture],
    );

    const architectureFactory = architectures.filter((ar) => ar.factoryId === currentFactory);

    return (
      <div className={styles.devicesWrapper}>
        <h2 className="page-title">{t('common.architecture')}</h2>
        <div className={styles.contentModule}>
          <div className={styles.moduleWrapper}>
            <div className={styles.headerWrapper}>
              <Dropdown
                placeholder={t('common.selectFactory')}
                selection
                options={factoryOptions}
                onChange={handleChangeFactory}
                value={currentFactory}
              />
              {isAdmin && (
                <AttachmentAddPopup onCreate={handleArchitectureCreate}>
                  <Button
                    floated="right"
                    className={classNames(styles.actionButton, styles.attachmentButton)}
                  >
                    <Icon name="attach" className={styles.actionIcon} />
                    {t('common.attachment')}
                  </Button>
                </AttachmentAddPopup>
              )}
            </div>
            {architectureFactory.length > 0 && (
              <Attachments items={architectureFactory} onDelete={onArchitectureDelete} />
            )}
          </div>
        </div>
      </div>
    );
  },
);

Architecture.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  architectures: PropTypes.arrayOf(PropTypes.any).isRequired,
  factories: PropTypes.arrayOf(PropTypes.any).isRequired,
  onArchitectureCreate: PropTypes.func.isRequired,
  onFetchArchitecture: PropTypes.func.isRequired,
  onArchitectureDelete: PropTypes.func.isRequired,
};

export default Architecture;
